import { forwardRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  PREVIOUS_ORDERS,
  PREVIOUS_ORDERS_TYPES,
} from "../../../../constants/order";
import { withClickOutside } from "../../../hoc/withClickOutside";
import dropdownArrow from "../../../../assets/icons/dropdown_arrow.svg";
import classes from "./PreviousOrdersDropdown.module.css";

const PreviousOrdersDropdown = forwardRef((props, ref) => {
  const { open, setOpen } = props;
  const [searchParams, setSearchParams] = useSearchParams();

  const previousOrdersToggleHandler = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const previousOrdersTypeChangedHandler = (type) => {
    searchParams.set("type", type);
    setSearchParams(searchParams);
    setOpen(false);
  };

  const dropdownMenuContent = Object.values(PREVIOUS_ORDERS).reduce(
    (acc, curr, index) => {
      if (
        curr ===
        (PREVIOUS_ORDERS[searchParams.get("type")?.toUpperCase()] ||
          PREVIOUS_ORDERS.NORMAL)
      ) {
        return [...acc];
      } else {
        return [
          ...acc,
          <li
            key={index}
            className={classes["previous-orders-dropdown__menu-item"]}
            role="button"
            onClick={() => previousOrdersTypeChangedHandler(curr)}
          >
            {PREVIOUS_ORDERS_TYPES.get(curr)}
          </li>,
        ];
      }
    },
    []
  );

  return (
    <div className={classes["previous-orders-dropdown"]} ref={ref}>
      <button
        className={classes["previous-orders-dropdown__btn"]}
        onClick={previousOrdersToggleHandler}
      >
        {PREVIOUS_ORDERS_TYPES.get(searchParams.get("type")) ||
          PREVIOUS_ORDERS_TYPES.get(PREVIOUS_ORDERS.NORMAL)}
        <img
          src={dropdownArrow}
          alt="arrow"
          className={classes["previous-orders-dropdown__arrow"]}
        />
      </button>
      {open && (
        <ul className={classes["previous-orders-dropdown__menu"]}>
          {dropdownMenuContent}
        </ul>
      )}
    </div>
  );
});

export default withClickOutside(PreviousOrdersDropdown);
